<template>
  <div class="row f-row">
    <div class="col col-12">
      <!-- ============= Logo / title =============  -->
      <div class="row f-row text-center">
        <div class="col col-12 mt-4 mb-2">
          <img
            :src="logo"
            @mouseover="logo = logo_blue"
            @mouseout="logo = logo_white"
            height="50"
            alt=""
            style="padding: 0"
          />
        </div>
      </div>
      <div
        class="row f-row text-center"
        style="border-bottom: 1px solid var(--graylightbackground);"
      >
        <div class="col col-12 mb-3">{{ quoteTrade }} FORM</div>
      </div>
      <!-- ============= form =============  -->
      <div class="row f-row justify-content-center">
        <div class="col col-6 mt-3">
          <div class="row f-row justify-content-center">
            <div class="col col-3 txt-label-primary-2-b">
              QUOTE MADE BY:
            </div>
            <div class="col col-8">
              <div class="row f-row">
                <div class="col col-8 selectDiv">
                  <select
                    class="dropdown-form"
                    v-model="newSelectedCompany"
                    @change="onUserCompanySelection"
                  >
                    <option
                      v-for="(company, index) in companies"
                      :value="index"
                      :key="company.id"
                    >
                      {{ company.company_name.toUpperCase() }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row f-row mt-1 justify-content-center">
            <div class="col col-3 txt-label-primary-2-b text-right">
              CURRENCY:
            </div>
            <div class="col col-8 no-dropdown">
              {{ selectedCurrency }}
            </div>
          </div>

          <div class="row f-row mt-1 justify-content-center">
            <div class="col col-3 txt-label-primary-2-b text-right">
              STRATEGY:
            </div>
            <div class="col col-8 no-dropdown">
              {{ strategyName }}
              <span style="color: var(--textinactive)">ON</span>
              {{ selectedCurrency.slice(0, 3) }}
            </div>
          </div>

          <div
            class="row f-row mt-1 justify-content-center"
            v-show="quoteTrade !== 'QUOTE'"
          >
            <div class="col col-3 txt-label-primary-2-b text-right">
              ORDER TYPE:
            </div>
            <div class="col col-8 text-left">
              <span style="width: 160px" class="ml-2">
                <label
                  :for="'selectOrder'"
                  class="toggle__button_order text-center"
                  style="height: 100%"
                  :class="{ actives: selectedOrderBoolean }"
                >
                  <input
                    type="checkbox"
                    @click="onUserOrderChange"
                    :id="'selectOrder'"
                    v-model="selectedOrderBoolean"
                  />
                  <span class="toggle__switch_order">
                    <div class="row f-row justify-content-center">
                      <div
                        class="col col-6 txt-label-primary-2 text-center"
                        style="font-size: 0.75rem!important; top: 2px;"
                      >
                        MARKET
                      </div>
                      <div
                        class="col col-6 txt-label-primary-2 text-center"
                        style="font-size: 0.75rem!important; top: 2px;"
                      >
                        LIMIT
                      </div>
                    </div>
                  </span>
                </label>
              </span>
            </div>
          </div>

          <div class="row f-row mt-1 justify-content-center">
            <div
              class="col col-3 txt-label-primary-2-b text-right"
              v-if="!selectedOrderBoolean"
            >
              SPOT REFERENCE:
            </div>
            <div class="col col-3 txt-label-primary-2-b text-right" v-else>
              WITH SPOT:
            </div>
            <div class="col col-8">
              <div class="row f-row mt-1">
                <div
                  class="col col-auto txt-label-primary-2 mr-1"
                  v-if="showLoadingSpot"
                >
                  <span class="mr-1">
                    <v-progress-circular
                      indeterminate
                      :size="14"
                      :width="1.5"
                      color="primary"
                    ></v-progress-circular>
                  </span>
                </div>
                <div class="col col-4 txt-label-primary-2 text-right">
                  <input
                    v-model.number.lazy="newSpot"
                    placeholder="spot"
                    class="custom-input input-sm"
                    @change="onUserSpotChange"
                  />
                </div>
                <div class="col col-auto">
                  <button class="btn updateSpot" v-on:click="onUserSpotRefresh">
                    <i class="fa fa-refresh"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!--          <div-->
          <!--            class="row f-row mt-1 justify-content-center"-->
          <!--            v-show="!isFwdOrFuture"-->
          <!--          >-->
          <!--            <div class="col col-3 txt-label-primary-2-b text-right">-->
          <!--              QUOTE TYPE-->
          <!--              <span class="ml-1">-->
          <!--                <i-->
          <!--                  class="fa fa-question-circle"-->
          <!--                  @mouseover="onHoverHelpQuoteType(true)"-->
          <!--                  @mouseleave="onHoverHelpQuoteType(false)"-->
          <!--                ></i></span-->
          <!--              >:-->
          <!--              <div class="help-trade-div text-center" v-if="showHelpQuoteType">-->
          <!--                <span v-if="selectedObjectiveBoolean">-->
          <!--                  Counterparties will quote the cost<br />of the defined strike-->
          <!--                  levels.-->
          <!--                </span>-->
          <!--                <span v-else>-->
          <!--                  Counterparties will quote the<br />selected leg's strike-->
          <!--                  levels,<br />keeping cost and other legs as defined.-->
          <!--                </span>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <div class="col col-6 text-left">-->
          <!--              <span style="width: 160px" class="ml-2">-->
          <!--                <label-->
          <!--                  :for="'selectObjective'"-->
          <!--                  class="toggle__button_objective text-center"-->
          <!--                  style="height: 100%"-->
          <!--                  :class="{ actives: selectedObjectiveBoolean }"-->
          <!--                >-->
          <!--                  <input-->
          <!--                    type="checkbox"-->
          <!--                    @click="onUserOrderCostOrStrike"-->
          <!--                    :id="'selectObjective'"-->
          <!--                    v-model="selectedObjectiveBoolean"-->
          <!--                  />-->
          <!--                  <span class="toggle__switch_objective">-->
          <!--                    <div class="row f-row justify-content-center">-->
          <!--                      <div-->
          <!--                        class="col col-6 txt-label-primary-2 text-center"-->
          <!--                        style="font-size: 0.75rem!important; top: 2px;"-->
          <!--                      >-->
          <!--                        STRIKE-->
          <!--                      </div>-->
          <!--                      <div-->
          <!--                        class="col col-6 txt-label-primary-2 text-center"-->
          <!--                        style="font-size: 0.75rem!important; top: 2px;"-->
          <!--                      >-->
          <!--                        COST-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                  </span>-->
          <!--                </label>-->
          <!--              </span>-->
          <!--            </div>-->
          <!--          </div>-->

          <div
            class="row f-row mt-1 justify-content-center"
            v-if="!selectedObjectiveBoolean && !isFwdOrFuture"
          >
            <div class="col col-3 txt-label-primary-2-b text-right">
              QUOTE FOLLOWING<span
                class="ml-1"
                v-show="strategies[0].first_second_strike_equal"
              >
                <i
                  class="fa fa-question-circle"
                  @mouseover="onHoverSameStrikeTxt(true)"
                  @mouseleave="onHoverSameStrikeTxt(false)"
                ></i></span
              >:
              <div class="help-trade-div text-center" v-if="showSameStrikeTxt">
                The first two legs ({{ strategyLegs[0] }} and
                {{ strategyLegs[1] }})<br />will have the same strike.
              </div>
            </div>
            <div class="col col-4">
              <table
                class="table table-sm table-borderless trade_process_table"
              >
                <tbody class="table-headers text-center align-center thead">
                  <tr>
                    <td
                      class="col text-left"
                      v-for="(item, index) in strategyLegs"
                      :key="index"
                      style="width: 60px;font-size: 0.75rem!important; color: var(--textactive)!important;"
                    >
                      <label class="radio_container">
                        <input
                          type="checkbox"
                          name="radio_leg_select"
                          :value="index"
                          v-model="newSelectedLegQuote"
                          @click="onClientLegSelect(index)"
                        />
                        <span class="radio_checkmark"></span>
                        <span class="inh">{{ item.toUpperCase() }}</span>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col col-4" style="z-index: -1;"></div>
          </div>

          <div
            class="row f-row mt-1 justify-content-center"
            v-for="(item, index) in strategyLegs.slice(0, -1)"
            :key="index"
          >
            <div class="col col-3 txt-label-primary-2-b text-right">
              {{ item }} AVERAGE:
            </div>
            <div class="col col-2">
              <InputNumber
                :value="newStrategyCost"
                @input="(val) => onUserCostChange(val)"
              />
            </div>
            <div class="col col-2 txt-label-primary-2-b text-right">
              SAME STRIKES?:
            </div>
            <div
              class="col col-2 txt-label-primary-2-b text-left justify-content-start"
            >
              <span style="width: 100%" class="ml-2">
                <label
                  :for="'leg' + item"
                  class="toggle__button_rt text-center"
                  style="height: 100%; width: 100%;"
                  :class="{ actives: selectedObjectiveBoolean }"
                >
                  <input
                    type="checkbox"
                    @click="onUserOrderCostOrStrike"
                    :id="'leg' + item"
                    v-model="selectedObjectiveBoolean"
                  />
                  <span class="toggle__switch_rt" style="width: 100%;">
                    <div class="row f-row justify-content-center">
                      <div
                        class="col col-6 txt-label-primary-2 text-center"
                        style="font-size: 0.75rem!important;"
                      >
                        YES
                      </div>
                      <div
                        class="col col-6 txt-label-primary-2 text-center"
                        style="font-size: 0.75rem!important;"
                      >
                        NO
                      </div>
                    </div>
                  </span>
                </label>
              </span>
            </div>
            <div class="col col-2"></div>
          </div>

          <div
            class="row f-row mt-1 justify-content-center"
            v-show="!isFwdOrFuture"
          >
            <div
              class="col col-3 txt-label-primary-2-b text-right"
              v-if="!selectedObjectiveBoolean"
            >
              PREMIUM ({{ baseCurrency.base }}):
            </div>
            <div class="col col-6">
              <div class="row f-row">
                <div class="col col-8" v-if="!selectedObjectiveBoolean">
                  <InputNumber
                    :value="newStrategyCost"
                    @input="(val) => onUserCostChange(val)"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row f-row mt-1 justify-content-center">
            <div class="col col-3 txt-label-primary-2-b text-right">
              ADDITIONAL:
            </div>
            <div class="col col-4 ml-1">
              <table
                class="table table-sm table-borderless trade_process_table"
              >
                <tbody class="table-headers text-center align-center thead">
                  <tr>
                    <td
                      class="col text-left"
                      style="width: 28%;font-size: 0.75rem!important; color: var(--textactive)!important;"
                    >
                      <label class="radio_container">
                        <input
                          type="radio"
                          name="radio_leg_select"
                          :value="0"
                          v-model="showDetails"
                        />
                        <span class="radio_checkmark"></span>
                        <span class="inh">HIDE</span>
                      </label>
                    </td>
                    <td
                      class="col text-left"
                      style="width: 46%;font-size: 0.75rem!important; color: var(--textactive)!important;"
                    >
                      <label class="radio_container">
                        <input
                          type="radio"
                          name="radio_leg_select"
                          :value="1"
                          v-model="showDetails"
                        />
                        <span class="radio_checkmark"></span>
                        <span class="inh">RECIPIENTS</span>
                      </label>
                    </td>
                    <td
                      class="col text-left"
                      style="width: 36%;font-size: 0.75rem!important; color: var(--textactive)!important;"
                    >
                      <label class="radio_container">
                        <input
                          type="radio"
                          name="radio_leg_select"
                          :value="2"
                          v-model="showDetails"
                        />
                        <span class="radio_checkmark"></span>
                        <span class="inh">STRIKES</span>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col col-2"></div>
          </div>
        </div>

        <div class="col col-1" v-if="showDetails === 1"></div>
        <div class="col col-3 mt-3" v-if="showDetails === 1">
          <div class="row f-row text-center">
            <div
              class="col col-12 mb-3 txt-label-primary-2"
              style="justify-content: flex-start!important;"
            >
              QUOTE WILL BE SENT TO THE SELECTED COUNTERPARTIES:
            </div>
          </div>
          <div v-if="showDetails === 1" class="max-h-quote mt-3">
            <table class="table table-sm table-borderless trade_process_table">
              <tbody class="table-headers text-center align-center thead">
                <tr v-for="(item, index) in newBanks" :key="index" class="tr">
                  <td class="text-left">
                    <label class="checkbox_container">
                      <input
                        type="checkbox"
                        name="checkbox_select"
                        :value="index"
                        v-model="item.include"
                        @click="onClientBankInclude"
                      />
                      <span class="checkbox_checkmark"></span>
                      <span
                        class="ml-2"
                        v-bind:class="{
                          'light-background-txt': !item.include,
                        }"
                        >{{ item.name }}</span
                      >
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col col-6 mt-3" v-if="showDetails === 2">
          <DateNotionalQuote
            :strategies="strategies"
            :strategyLegs="strategyLegs"
            :userNewHedge="userNewHedge"
            :averages="averages"
            :selectedAsset="selectedAsset"
            :currencySpecs="currencySpecs"
            :quoteObjective="quoteObjective"
            :selectedLegQuote="newSelectedLegQuote"
            :isFwdOrFuture="isFwdOrFuture"
          />
        </div>
      </div>

      <div class="row f-row justify-content-center mt-5">
        <div class="col col-1">
          <button
            v-on:click="onUserCancelQuote"
            class="btn btn-home btn-abort"
            style="z-index: 1"
          >
            Cancel
          </button>
        </div>
        <div class="col col-1"></div>
        <div class="col col-1">
          <button
            v-on:click="onUserQuote"
            class="btn btn-home"
            :disabled="nBanks === 0"
          >
            RFQ
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateNotionalQuote from "@/components/hedge/DateNotionalQuote";
import InputNumber from "@/components/InputNumber";
import { sum } from "d3";

export default {
  name: "QuoteTradeInputs",
  components: {
    DateNotionalQuote,
    InputNumber,
  },
  props: {
    averages: { required: true, default: () => [] },
    banks: { required: true, default: () => [] },
    baseCurrency: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
    companies: { required: true, default: () => [] },
    currencySpecs: { required: true, default: () => [] },
    editable: { required: false, type: Boolean, default: false },
    isFwdOrFuture: { required: true, type: Boolean, default: false },
    notional: { required: true, default: () => [] },
    orderType: { required: true },
    position: { required: true, default: () => [] },
    quoteObjective: { required: true },
    quoteTrade: { required: true, default: "QUOTE" },
    refUserData: { required: true, default: () => [] },
    selectedAsset: { required: true, default: () => [] },
    selectedCompany: { required: true, default: () => [] },
    selectedCurrency: { required: true, default: () => [] },
    selectedLegQuote: { required: true },
    showLoadingSpot: { required: true, type: Boolean, default: false },
    spot: { required: true },
    strategies: { required: true, default: () => [] },
    strategyCost: { required: true, default: 0 },
    strategyLegs: { required: true, default: () => [] },
    strategyName: { required: true, default: () => [] },
    userNewHedge: { required: true, default: () => [] },
  },
  data() {
    return {
      logo_white: require("@/assets/images/symbol_white.svg"),
      logo_blue: require("@/assets/images/symbol_blue.svg"),
      logo: require("@/assets/images/symbol_white.svg"),
      showHelpQuoteType: false,
      newSelectedCompany: 0,
      newSpot: 0,
      newOrderType: "market",
      newQuoteObjective: "strike",
      newStrategyCost: 0,
      newSelectedLegQuote: [],
      newBanks: [],
      showDetails: 2,
      showSameStrikeTxt: false,
    };
  },
  mounted() {
    this.newSelectedCompany = this.selectedCompany;
    this.newSpot = this.spot;
    this.newOrderType = this.orderType;
    this.newQuoteObjective = this.quoteObjective;
    this.newStrategyCost = this.strategyCost;
    this.newSelectedLegQuote = this.selectedLegQuote;
    this.newBanks = this.banks;
    if (!this.colorTheme) {
      this.logo_white = require("@/assets/images/symbol_black.svg");
      this.logo = require("@/assets/images/symbol_black.svg");
    }
  },
  computed: {
    selectedOrderBoolean: {
      get() {
        return this.newOrderType === "limit";
      },
      set() {
        return false;
      },
    },
    selectedObjectiveBoolean: {
      get() {
        return this.newQuoteObjective === "cost";
      },
      set() {
        return false;
      },
    },
    nBanks() {
      return sum(this.newBanks, function(d) {
        return d.include === true ? 1 : 0;
      });
    },
  },
  watch: {
    colorTheme(val) {
      if (val) {
        this.logo_white = require("@/assets/images/symbol_white.svg");
        this.logo = require("@/assets/images/symbol_white.svg");
      } else {
        this.logo_white = require("@/assets/images/symbol_black.svg");
        this.logo = require("@/assets/images/symbol_black.svg");
      }
    },
    selectedCompany() {
      this.newSelectedCompany = this.selectedCompany;
    },
    spot(val) {
      this.newSpot = val;
    },
    orderType(val) {
      this.newOrderType = val;
    },
    quoteObjective(val) {
      this.newQuoteObjective = val;
    },
    strategyCost(val) {
      this.newStrategyCost = val;
    },
    selectedLegQuote(val) {
      this.newSelectedLegQuote = val;
    },
    banks(val) {
      this.newBanks = val;
    },
  },
  methods: {
    onHoverSameStrikeTxt(val) {
      this.showSameStrikeTxt = val;
    },
    onClientBankInclude() {
      this.$emit("eventOnClientBankInclude", this.newBanks);
    },
    onClientLegSelect(idx) {
      setTimeout(() => {
        if (idx > 1) {
          this.newSelectedLegQuote = [idx];
        } else {
          if (this.strategies[0].first_second_strike_equal) {
            this.newSelectedLegQuote = [0, 1];
          } else {
            this.newSelectedLegQuote = [idx];
          }
        }
        this.$emit("eventOnClientLegSelect", this.newSelectedLegQuote);
      }, 30);
    },
    onUserCompanySelection() {
      this.$emit("eventOnUserCompanySelection", this.newSelectedCompany);
    },
    onUserOrderCostOrStrike() {
      this.newQuoteObjective =
        this.newQuoteObjective === "strike" ? "cost" : "strike";
      this.$emit("eventOnUserOrderCostOrStrike", this.newQuoteObjective);
    },
    onUserOrderChange() {
      this.newOrderType = this.newOrderType === "market" ? "limit" : "market";
      this.$emit("eventOnUserOrderChange", this.newOrderType);
    },
    onUserSpotChange() {
      this.$emit("eventOnUserSpotChange", this.newSpot);
    },
    onUserSpotRefresh() {
      this.$emit("eventOnUserSpotRefresh");
    },
    onUserCostChange(val) {
      this.$emit("eventOnUserCostChange", val);
    },
    onUserCancelQuote() {
      this.$emit("eventOnUserCancelQuote");
    },
    onUserQuote() {
      this.$emit("eventOnUserQuote");
    },
    onHoverHelpQuoteType(val) {
      this.showHelpQuoteType = val;
    },
  },
};
</script>

<style scoped>
/* radio checkboxes */
.radio_container {
  width: 100%;
  display: block;
  position: relative;
  top: 4px;
  left: 20px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/* Hide the browser's default radio button */
.radio_container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
/* Create a custom radio button */
.radio_checkmark {
  position: absolute;
  top: 2px;
  left: -18px;
  height: 14px;
  width: 14px;
  background-color: var(--lightbackground);
  border-radius: 50%;
}
/* On mouse-over, add a grey background color */
.radio_container:hover input ~ .radio_checkmark {
  background-color: var(--lightbackground2);
}
/* When the radio button is checked, add a blue background */
.radio_container input:checked ~ .radio_checkmark {
  background-color: var(--lightbackground);
}
/* Create the indicator (the dot/circle - hidden when not checked) */
.radio_checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
/* Show the indicator (dot/circle) when checked */
.radio_container input:checked ~ .radio_checkmark:after {
  display: block;
}
/* Style the indicator (dot/circle) */
.radio_container .radio_checkmark:after {
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--expo);
}

/* ======= first selector: order type ======= */
.toggle__button_order {
  vertical-align: middle !important;
  user-select: none;
  cursor: pointer;
}
.toggle__button_order input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
}
.toggle__button_order .toggle__switch_order {
  display: inline-block;
  height: 20px;
  border-radius: 10px;
  width: 160px;
  background: var(--lightbackground);
  box-shadow: inset 0 0 1px var(--lightbackground);
  position: relative;
  margin: 5px 0 0 0;
  top: 2px;
  transition: all 0.25s;
}
.toggle__button_order .toggle__switch_order::after,
.toggle__button_order .toggle__switch_order::before {
  content: "MARKET";
  font-size: 0.8rem;
  position: absolute;
  display: block;
  height: 20px;
  width: 80px;
  border-radius: 10px;
  left: 0;
  top: 0;
  transform: translateX(0);
  transition: all 0.3s cubic-bezier(0.17, 0.67, 0.83, 0.67);
}
.toggle__button_order .toggle__switch_order::after {
  background: var(--graylightbackground);
  border: 1px solid var(--graylightbackground);
  box-shadow: 0 0 1px var(--graylightbackground);
  color: var(--textactive);
}
.toggle__button_order .toggle__switch_order::before {
  background: var(--lightbackground);
  border: 1px solid var(--lightbackground);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
  opacity: 0;
}
.actives .toggle__switch_order {
  background: var(--lightbackground);
  box-shadow: inset 0 0 1px var(--lightbackground);
  color: var(--textactive);
}
.actives .toggle__switch_order::after,
.actives .toggle__switch_order::before {
  content: "LIMIT";
}
.actives .toggle__switch_order::after {
  left: 80px;
  background: var(--graylightbackground);
  border: 1px solid var(--graylightbackground);
  box-shadow: 0 0 1px var(--graylightbackground);
}

/* ======= second selector: cost or strike ======= */
.toggle__button_objective {
  vertical-align: middle !important;
  user-select: none;
  cursor: pointer;
}
.toggle__button_objective input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
}
.toggle__button_objective .toggle__switch_objective {
  display: inline-block;
  height: 20px;
  border-radius: 10px;
  width: 160px;
  background: var(--lightbackground);
  box-shadow: inset 0 0 1px var(--lightbackground);
  position: relative;
  margin: 5px 0 0 0;
  top: 2px;
  transition: all 0.25s;
}
.toggle__button_objective .toggle__switch_objective::after,
.toggle__button_objective .toggle__switch_objective::before {
  content: "STRIKE";
  font-size: 0.8rem;
  position: absolute;
  display: block;
  height: 20px;
  width: 80px;
  border-radius: 10px;
  left: 0;
  top: 0;
  transform: translateX(0);
  transition: all 0.3s cubic-bezier(0.17, 0.67, 0.83, 0.67);
}
.toggle__button_objective .toggle__switch_objective::after {
  background: var(--graylightbackground);
  border: 1px solid var(--graylightbackground);
  box-shadow: 0 0 1px var(--graylightbackground);
  color: var(--textactive);
}
.toggle__button_objective .toggle__switch_objective::before {
  background: var(--lightbackground);
  border: 1px solid var(--lightbackground);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
  opacity: 0;
}
.actives .toggle__switch_objective {
  background: var(--lightbackground);
  box-shadow: inset 0 0 1px var(--lightbackground);
  color: var(--textactive);
}
.actives .toggle__switch_objective::after,
.actives .toggle__switch_objective::before {
  content: "COST";
}
.actives .toggle__switch_objective::after {
  left: 80px;
  background: var(--graylightbackground);
  border: 1px solid var(--graylightbackground);
  box-shadow: 0 0 1px var(--graylightbackground);
}

/* ======= third selector: same strike yes/no ======= */

.toggle__button_rt .toggle__switch_rt::after,
.toggle__button_rt .toggle__switch_rt::before {
  content: "YES";
  font-size: 0.8rem !important;
}
.actives .toggle__switch_rt::after,
.actives .toggle__switch_rt::before {
  content: "NO";
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transition: opacity 0.5s;
}

/* checkbox checkboxes */
.checkbox_container {
  width: 80%;
  display: block;
  position: relative;
  left: 20px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/* Hide the browser's default checkbox button */
.checkbox_container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
/* Create a custom radio button */
.checkbox_checkmark {
  position: absolute;
  top: 3px;
  left: -14px;
  height: 14px;
  width: 14px;
  background-color: var(--lightbackground);
  border-radius: 2%;
}
/* On mouse-over, add a grey background color */
.checkbox_container:hover input ~ .checkbox_checkmark {
  background-color: var(--lightbackground2);
}
/* When the checkbox button is checked, add a blue background */
.checkbox_container input:checked ~ .checkbox_checkmark {
  background-color: var(--lightbackground);
}
/* Create the indicator (the dot/circle - hidden when not checked) */
.checkbox_checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
/* Show the indicator (dot/circle) when checked */
.checkbox_container input:checked ~ .checkbox_checkmark:after {
  display: block;
}
/* Style the indicator (dot/circle) */
.checkbox_container .checkbox_checkmark:after {
  content: "\2714";
  font-size: 0.75rem;
  top: -2px;
  left: 2px;
  color: var(--expo);
}
</style>
